import { LUGARES_INFO } from "./rutaTokioLugaresInfo";

const RUTA_TOKIO = {
	id: "tokio",
	title: "TOKIO",
	subtitle: "EN 4 DÍAS",
	description: "La ruta perfecta para descubrir lo mejor de Tokio en 4 días ✨",
	stats: { days: 4, distance: "+25 km", difficulty: "Fácil" },
	color: "#f8a4b8",
	colorLight: "#fff0f3",
	colorAccent: "#e8677d",
	emoji: "🗼",
	days: [
		{
			id: 1,
			title: "YOYOGI + HARAJUKU + SHIBUYA",
			zone: "",
			description:
				"Tu primer día empieza con calma en el Santuario Meiji y Yoyogi Park. Después, contraste total: la locura kawaii de Takeshita Street y la moda de Omotesando. Terminas en Shibuya con el cruce más famoso del mundo.",
			highlights: [
				"Santuario Meiji",
				"Takeshita Street",
				"Omotesando",
				"Shibuya Crossing",
				"Shibuya Sky",
			],
			mapPosition: { top: "20%", left: "35%" },
			dotOffset: { top: "18px", left: "0" },
			illustrations: [
				{
					src: "/rutas/tokio-yoyogi.png",
					photo: "/rutas/fotos/yoyogi.png",
					name: "Yoyogi",
					offset: { top: "-55px", left: "-75px" },
					info: LUGARES_INFO.yoyogi,
				},
				{
					src: "/rutas/tokio-harajuku.png",
					photo: "/rutas/fotos/harajuku.png",
					name: "Harajuku",
					offset: { top: "-60px", left: "15px" },
					info: LUGARES_INFO.harajuku,
				},
				{
					src: "/rutas/tokio-shibuya.png",
					photo: "/rutas/fotos/shibuya.png",
					name: "Shibuya",
					offset: { top: "-35px", left: "100px" },
					info: LUGARES_INFO.shibuya,
				},
			],
		},
		{
			id: 2,
			title: "ASAKUSA + UENO + AKIHABARA",
			zone: "",
			description:
				"Arrancas en Asakusa con el templo Senso-ji y el Tokio antiguo, sigues a Ueno (parque, zoo, museos) y terminas con la locura otaku de Akihabara. Tres Tokios muy distintos en un día.",
			highlights: [
				"Senso-ji",
				"Kaminarimon",
				"Ameyoko Market",
				"Electric Town",
			],
			mapPosition: { top: "28%", left: "70%" },
			dotOffset: { top: "-8px", left: "0" },
			illustrations: [
				{
					src: "/rutas/tokio-asakusa.png",
					photo: "/rutas/fotos/asakusa.png",
					name: "Asakusa",
					offset: { top: "28px", left: "5px" },
					info: LUGARES_INFO.asakusa,
				},
				{
					src: "/rutas/tokio-ueno.png",
					photo: "/rutas/fotos/ueno.png",
					name: "Ueno",
					anchor: "center",
					offset: { top: "95px", left: "-20px" },
					info: LUGARES_INFO.ueno,
				},
				{
					src: "/rutas/tokio-akihabara.png",
					photo: "/rutas/fotos/akihabara.png",
					name: "Akihabara",
					anchor: "center",
					offset: { top: "155px", left: "-55px" },
					info: LUGARES_INFO.akihabara,
				},
			],
		},
		{
			id: 3,
			title: "TOKYO STATION + GINZA + ODAIBA",
			zone: "",
			description:
				"Un día de contrastes: la elegancia de Tokyo Station y Ginza por la mañana, seguido de la isla futurista de Odaiba con Rainbow Bridge al atardecer.",
			highlights: [
				"Tokyo Station",
				"Palacio Imperial",
				"Mercado Tsukiji",
				"Rainbow Bridge",
				"Gundam gigante",
			],
			mapPosition: { top: "47%", left: "30%" },
			dotOffset: { top: "55px", left: "-75px" },
			illustrations: [
				{
					src: "/rutas/tokio-station.png",
					photo: "/rutas/fotos/tokio-station.png",
					name: "Tokyo Station",
					anchor: "center",
					offset: { top: "55px", left: "25px" },
					info: LUGARES_INFO.tokyoStation,
				},
				{
					src: "/rutas/tokio-ginza.png",
					photo: "/rutas/fotos/ginza.png",
					name: "Ginza",
					anchor: "center",
					offset: { top: "125px", left: "40px" },
					info: LUGARES_INFO.ginza,
				},
				{
					src: "/rutas/tokio-odaiba.png",
					photo: "/rutas/fotos/odaiba.png",
					name: "Odaiba",
					anchor: "center",
					offset: { top: "110px", left: "115px" },
					info: LUGARES_INFO.odaiba,
				},
			],
		},
		{
			id: 4,
			title: "TORRE DE TOKIO + SHINJUKU",
			zone: "Minato-ku / Shinjuku-ku",
			description:
				"El broche perfecto: Torre de Tokio con vistas 360° y el templo Zojo-ji al lado. Por la noche, Shinjuku: la vista gratis desde el TMG Building, yakitori en Omoide Yokocho y bares en Golden Gai.",
			highlights: [
				"Torre de Tokio",
				"Zojo-ji",
				"Golden Gai",
				"Omoide Yokocho",
				"TMG Building (gratis)",
			],
			mapPosition: { top: "80%", left: "70%" },
			dotOffset: { top: "-30px", left: "0" },
			illustrations: [
				{
					src: "/rutas/tokio-torre.png",
					photo: "/rutas/fotos/torre-tokio.png",
					name: "Torre de Tokio",
					anchor: "center",
					offset: { top: "-40px", left: "-60px" },
					mobileOffset: { top: "-20px", left: "-35px" },
					info: LUGARES_INFO.torreTokio,
				},
				{
					src: "/rutas/tokio-shinjuku.png",
					photo: "/rutas/fotos/shinjuku.png",
					name: "Shinjuku",
					anchor: "center",
					offset: { top: "28px", left: "5px" },
					mobileOffset: { top: "28px", left: "28px" },
					info: LUGARES_INFO.shinjuku,
				},
			],
		},
	],
	badges: [
		{
			id: "explorer",
			name: "Explorador Tokio",
			emoji: "🗺️",
			unlockCondition: "Completa el día 1",
		},
		{
			id: "matcha",
			name: "Fan del matcha",
			emoji: "🍵",
			unlockCondition: "Visita una tetería",
		},
		{
			id: "lights",
			name: "Amo las luces",
			emoji: "✨",
			unlockCondition: "Completa Shibuya de noche",
		},
		{
			id: "culture",
			name: "Cultura lover",
			emoji: "⛩️",
			unlockCondition: "Visita 2 templos",
		},
		{
			id: "keep-going",
			name: "Sigue explorando…",
			emoji: "❓",
			unlockCondition: "Completa todos los días",
		},
	],
	favorites: [
		{
			id: "omoide",
			name: "Callejón de Omoide Yokocho",
			zone: "Shinjuku",
			image: "omoide-yokocho",
		},
		{
			id: "crossing",
			name: "Shibuya Crossing",
			zone: "Shibuya",
			image: "shibuya-crossing",
		},
		{
			id: "2d-cafe",
			name: "2D Café",
			zone: "Shin-Okubo",
			image: "2d-cafe",
		},
	],
};

export default RUTA_TOKIO;
